import React from "react";
import { Grid, Row, Col } from "../../utils/bootstrap";
import { FOOTER_MENU } from "../../utils/constants";
import LazyLoad from "react-lazyload";
import "./index.css";
import close from "../../images/landing-page-menu-close.svg";

const HomeMenu = ({
  menu,
  history,
  toggleModal,
  showRedirectModal,
  show,
  closeModal
}) => {
  const renderMenu = () => {
    return menu.map(({ name, link, type }) => {
      if (name === "separation") {
        return (
          <Col lg={12} key="separator">
            <hr className="home-menu-separate" />
          </Col>
        );
      } else if (type === "function") {
        return (
          <Col
            lg={12}
            className="menu-link"
            onClick={() => toggleModal()}
            key={`func-${name}`}
          >
            {name}
          </Col>
        );
      } else if (type === "redirect") {
        return (
          <Col
            lg={12}
            className="menu-link"
            onClick={showRedirectModal}
            key={`redirect-${name}`}
          >
            {name}
          </Col>
        );
      } else {
        return (
          <Col
            lg={12}
            className="menu-link"
            onClick={() => history.push(link)}
            key={`link-${name}`}
          >
            {name}
          </Col>
        );
      }
    });
  };

  const renderFooter = () => {
    return FOOTER_MENU.map(({ name, link, icon }) => {
      return (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          key={`footer-${name}`}
        >
          <LazyLoad>
            <img
              src={icon}
              alt={name}
              className="pointer footer-social-links"
            />
          </LazyLoad>
        </a>
      );
    });
  };

  return (
    <div>
      <div className={`home-menu${show ? " home-menu-open" : ""}`}>
        <Grid>
          <Row>
            <Col lg={12}>
              {show && (
                <img
                  src={close}
                  alt="close menu"
                  className="menu-link"
                  onClick={closeModal}
                />
              )}
            </Col>
            <Col lg={12} className="hidden-xs">
              <hr className="home-menu-separate" />
            </Col>
            {renderMenu()}
          </Row>
          <div className="social-links hidden-xs">
            <div>{renderFooter()}</div>
          </div>
        </Grid>
      </div>
    </div>
  );
};

export default HomeMenu;
